// extracted by mini-css-extract-plugin
export default {"traySpeedMedium":"TrayToggle_traySpeedMedium__3nH4B","traySpeedFast":"TrayToggle_traySpeedFast__vr1ZK","tray_container":"TrayToggle_tray_container__yiyh4"};